import globalAxios, { AxiosPromise, AxiosInstance } from "axios";
import { Configuration } from "../../configuration";
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  toPathString,
  createRequestFunction,
} from "../../common";
// @ts-ignore
import { STG_PATH, RequestArgs, BaseAPI } from "../../base";

interface Productavailability {
  code?: string;
  description?: string;
  reasonCode?: string;
}
/**
 * validaSocioApi - axios parameter creator
 * @export
 */
export const ProductAvailabilityApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     * Validates noSocio.
     *
     * @summary Get details by part number
     * @param {string} storeId The store identifier.
     * @param {string} noSocio The socio number.
     * @throws {RequiredError}
     * @memberof InventoryAvailabilityApi
     */
    validaSocio: async (
      storeId: string,
      noSocio: string
    ): Promise<RequestArgs> => {
      // verify required parameter 'storeId' is not null or undefined
      assertParamExists(
        "validaSocio",
        "storeId",
        storeId
      );
      // verify required parameter 'noSocio' is not null or undefined
      assertParamExists(
        "validaSocio",
        "noSocio",
        noSocio
      );
      const localVarPath =
        `/store/{storeId}/ValidaSocio?responseFormat=json`
          .replace(`{${"storeId"}}`, String(storeId));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, data: {idCliente: noSocio, tipoCliente: "1"} };
      const localVarHeaderParameter = {} as any;

      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }
  };
};

/**
 * InventoryAvailabilityApi - functional programming interface
 * @export
 */
export const validaSocioApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator =
    ProductAvailabilityApiAxiosParamCreator(configuration);
  return {
    /**
     * Validates noSocio.
     *
     * @summary Get details by part number
     * @param {string} storeId The store identifier.
     * @param {string} noSocio The socio number.
     * @throws {RequiredError}
     * @memberof InventoryAvailabilityApi
     */
    async validaSocio(
      storeId: string,
      noSocio: string
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<Productavailability>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.validaSocio(
          storeId,
          noSocio
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        STG_PATH,
        configuration
      );
    }
  };
};

/**
 * validaSocioApi - factory interface
 * @export
 */
export const validaSocioApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = validaSocioApiFp(configuration);
  return {
    /**
     * Validates noSocio.
     *
     * @summary Get details by part number
     * * @param {string} storeId The store identifier.
     * @param {string} noSocio The socio number.
     * @throws {RequiredError}
     * @memberof InventoryAvailabilityApi
     */
    validaSocio(
      storeId: string,
      noSocio: string
    ): AxiosPromise<Productavailability> {
      return localVarFp
        .validaSocio(storeId, noSocio)
        .then((request) => request(axios, basePath));
    }
  };
};

/**
 * validaSocioApi - object-oriented interface
 * @export
 * @class InventoryAvailabilityApi
 * @extends {BaseAPI}
 */
export class ValidaSocioApi extends BaseAPI {
  /**
   * Validates noSocio.
   *
   * @summary Get details by part number
   * * @param {string} storeId The store identifier.
   * @param {string} noSocio The socio number.
   * @throws {RequiredError}
   * @memberof InventoryAvailabilityApi
   */
  public validaSocio(
    storeId: string,
    noSocio: string
  ) {
    return validaSocioApiFp(this.configuration)
      .validaSocio(storeId, noSocio)
      .then((request) => request(this.axios, this.basePath));
  }
}
